<template>
    <div class="container content-wrapper justify-content-center">
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="clearfix">
                    <h1 class="float-left display-3 me-4">401</h1>
                    <h4 class="pt-3">Oops!</h4>
                    <p class="text-muted" v-html="message" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Page401",
    props: {
        message: { type: String, default: 'You do not have access to the page you requested.' }
    }
};
</script>